import { Component, Input } from '@angular/core';
import { TermDisclosureInfo } from '../../apr-calculator.model';

@Component({
    selector: 'ifa-apr-disclosure-ca-term',
    templateUrl: './apr-disclosure-ca-term.component.html',
    styleUrls: ['../../apr-disclosure.component.scss', './apr-disclosure-ca-term.component.scss'],
    standalone: false
})
export class AprDisclosureCaTermComponent {

    @Input() data: TermDisclosureInfo = new TermDisclosureInfo('', 0, 0, null, null, 0);
}